// Localized learning-journey graphic; locales with no asset fall back to English.
import type { LocalizedImageMap } from '../../utils';

import journeyEn from './journey-en.svg';
import journeyEs from './journey-es.png';
import journeyFr from './journey-fr.png';
import journeyHi from './journey-hi.png';
import journeySw from './journey-sw.png';
import journeyZh from './journey-zh.png';

export {
  journeyEn, journeyEs, journeyFr, journeyHi, journeySw, journeyZh,
};

// Shared by every consumer of this artwork (HomePage, AboutUs).
export const journeyImages: LocalizedImageMap = {
  en: journeyEn,
  'es-419': journeyEs,
  fr: journeyFr,
  hi: journeyHi,
  sw: journeySw,
  'zh-cn': journeyZh,
};
